export const semanaEmpresa = [
    'hr_seg',
    'hr_ter',
    'hr_qua',
    'hr_qui',
    'hr_sex',
    'hr_sab',
    'hr_dom'
]